<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのWebページで読み込まれているJavaScriptは縮小されており、ページのロード時間を短縮できています。
        </p>
        <p v-else>
          あなたのWebページで読み込まれているJavaScriptは縮小されておらず、ページのロード時間を短縮できていません。
        </p>
      </div>
    </li>
    <li v-if="jsMinifyUnminifiedLinks.length" class="c-list--checkup__item">
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <ul class="c-list--disc">
          <li v-for="(item, index) in jsMinifyUnminifiedLinks" :key="index">
            {{ item.url }}
          </li>
        </ul>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          JavaScriptの内容を縮小することでページのロード時間が短縮されます。
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    jsMinifyUnminifiedLinks() {
      if (this.detail.link.unminified) {
        return this.detail.link.unminified.filter(item => item.url);
      }
      return [];
    }
  }
};
</script>
